/** @format */

// 对账结果 00未对账 01待对账  02对账中 03无文件 04成功 05失败
export enum ReconciliationResult {
  NoReconciliationResult = '00',
  StayReconciliationResult = '01',
  LoadReconciliationResult = '02',
  NoFile = '03',
  SuccessReconciliation = '04',
  FailReconciliation = '05'
}

export const reconciliationResultMap: {
  [key: string]: string;
} = {
  [ReconciliationResult.NoReconciliationResult]: '未对账',
  [ReconciliationResult.StayReconciliationResult]: '待对账',
  [ReconciliationResult.LoadReconciliationResult]: '对账中',
  [ReconciliationResult.NoFile]: '无文件',
  [ReconciliationResult.SuccessReconciliation]: '成功',
  [ReconciliationResult.FailReconciliation]: '失败'
};

// 下账状态 00：未下账 01：已下账
export enum ReconciliationStatus {
  NoEata = '00',
  YesEata = '01'
}

export const reconciliationStatusMap: {
  [key: string]: string;
} = {
  [ReconciliationStatus.NoEata]: '未下账',
  [ReconciliationStatus.YesEata]: '已下账'
};

// 	对账结果 00 ：对账不一致.  01：对账一致  02：已平账
export enum FlatAccount {
  AtypismFlatAccount = '00',
  VerifyFlatAccount = '01',
  YesFlatAccount = '02'
}

export const flatAccountMap: {
  [key: string]: string;
} = {
  [FlatAccount.AtypismFlatAccount]: '对账不一致',
  [FlatAccount.VerifyFlatAccount]: '对账一致',
  [FlatAccount.YesFlatAccount]: '已平账'
};

/**
 * 业务类型
 * 01：停车费 02：车位管理费
 */

export enum CheckType {
  Parking = '00',
  ParkingFee = '01',
  ParkingRent = '02'
}

export const checkTypeMap: {
  [key: string]: string;
} = {
  [CheckType.Parking]: '停车费',
  [CheckType.ParkingFee]: '车位管理费',
  [CheckType.ParkingRent]: '车位租赁费'
};

// 本地明细对账 支付方式    00：现金  04：ETC  99：其他

export enum LocalPayType {
  Cash = '00',
  ETC = '04',
  Other = '99'
}

export const localPayTypeMap: {
  [key: string]: string;
} = {
  [LocalPayType.Cash]: '现金',
  [LocalPayType.ETC]: 'ETC',
  [LocalPayType.Other]: '其他'
};

// 线上支付对账    对账平台     01 ：微信    02：支付宝    99：第三方

export enum OnLinePlatform {
  WeChat = '01',
  AliPay = '02',
  ThirdParty = '99'
}

export const onLinePlatformMap: {
  [key: string]: string;
} = {
  [OnLinePlatform.WeChat]: '微信',
  [OnLinePlatform.AliPay]: '支付宝',
  [OnLinePlatform.ThirdParty]: '第三方'
};
// 线上支付对账    对账状态  04对账成功   05对账失败    02无对账文件、 03对账中
export enum OnlineReconciliation {
  Success = '04',
  Fail = '05',
  NoFile = '03',
  Load = '02',
  NoLoad = '00'
}

export const onlineReconciliationMap: {
  [key: string]: string;
} = {
  [OnlineReconciliation.Success]: '对账成功',
  [OnlineReconciliation.Fail]: '对账失败',
  [OnlineReconciliation.NoFile]: '无对账文件',
  [OnlineReconciliation.Load]: '对账中',
  [OnlineReconciliation.NoLoad]: '未对账'
};

// 支付明细对账    对账结果  01对账成功   01对账失败
export enum detailReconciliationResult {
  Success = '01',
  Fail = '00',
  Ping = '02'
}

export const detailReconciliationResultMap: {
  [key: string]: string;
} = {
  [detailReconciliationResult.Success]: '对账一致',
  [detailReconciliationResult.Fail]: '对账不一致',
  [detailReconciliationResult.Ping]: '已平账'
};
